import { CampaignsApp } from '@datapad/campaigns';
import { assertNotUndefined } from '@datapad/utilities';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { DatapadAppStateContext } from '../../../utilities';
import { AppId } from '../AppId';

/**
 * Campaigns app wrapper.
 *
 * @remarks
 * Handles URL parameter management for campaign selection.
 * URL format: `/campaigns?id=<campaign-id>`
 * Campaigns are retrieved via {@link AppContext.getAllCampaigns}.
 */
export function Campaigns(): React.ReactElement {
	const location = useLocation();

	const { changeAppSelection } = assertNotUndefined(React.useContext(DatapadAppStateContext));

	// Parse URL for selection
	const searchParams = new URLSearchParams(location.search);
	const selectedId = searchParams.get('id') ?? undefined;

	// Handle selection changes by updating URL
	const handleSelectionChange = React.useCallback(
		(campaignId: string | undefined) => {
			const search = campaignId ? `id=${campaignId}` : '';
			changeAppSelection(AppId.Campaigns, search, undefined);
		},
		[changeAppSelection],
	);

	return <CampaignsApp selection={selectedId} changeSelection={handleSelectionChange} />;
}
